<template>
	<div>
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center v-resize="onResize">
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Integrazioni</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<v-menu bottom :close-on-click="true" elevation-0>
									<template v-slot:activator="{ on, attrs }">
										<v-btn elevation="0" v-bind="attrs" v-on="on" text>
											<v-icon>mdi-plus</v-icon>
										</v-btn>
									</template>
									<v-list elevation="0">
										<v-list-item @click="createItem">
											<v-list-item-icon>
												<v-icon>mdi-plus</v-icon>
											</v-list-item-icon>
											<v-list-item-content>
												<v-list-item-title>Nuova integrazione</v-list-item-title>
											</v-list-item-content>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-toolbar-items>
						</v-toolbar>

						<v-col cols="12">
							<v-row>
								<v-col cols="12" md="6">
									<v-text-field
										v-model="searchfield"
										label="Cerca per nome"
										outlined
										append-icon="mdi-magnify"
										dense
										hide-details
										@click:append="getSearch()"
										@keyup.enter="getSearch()"
									></v-text-field>
								</v-col>
								<v-col cols="12" md="4">
									<v-select
										v-model="filterType"
										:items="typeOptions"
										label="Tipo"
										outlined
										dense
										hide-details
										clearable
										@change="onFilterChange"
									></v-select>
								</v-col>
							</v-row>
						</v-col>

						<v-data-table
							:headers="headers"
							:items="getIntegrations"
							:options.sync="settings.options"
							:server-items-length="total"
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="integration-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.name || ''" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small v-bind="attrs" v-on="on" color="primary">
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<template v-if="item.icona || item.black" v-slot:top>
													<div class="d-flex mb-2" style="gap: 8px">
														<v-avatar size="32" tile v-if="item.icona">
															<img :src="item.icona" :alt="item.name" />
														</v-avatar>
														<v-avatar size="32" tile color="grey lighten-3" v-if="item.black">
															<img :src="item.black" :alt="item.name" />
														</v-avatar>
													</div>
												</template>
											</key-value-card>
										</td>
									</tr>
									<tr v-if="items.length === 0">
										<td :colspan="headers.length" class="grey--text text-center py-4">Nessun elemento</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense>
														<v-icon dark>mdi-dots-vertical</v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td>
											<v-avatar size="32" tile v-if="item.icona">
												<img :src="item.icona" :alt="item.name" />
											</v-avatar>
										</td>
										<td>
											<v-avatar size="32" tile color="grey lighten-3" v-if="item.black">
												<img :src="item.black" :alt="item.name" />
											</v-avatar>
										</td>
										<td>{{ item.name }}</td>
										<td>{{ item.service }}</td>
										<td>{{ item.type }}</td>
										<td>{{ formatPrice(item.setup) }}</td>
										<td>{{ formatPrice(item.canone) }}</td>
										<td>{{ item.created_at | moment('DD/MM/YYYY') }}</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>

					<v-snackbar
						v-model="snackbar.snackbar"
						:color="snackbar.color"
						:multi-line="snackbar.mode === 'multi-line'"
						:timeout="snackbar.timeout"
					>
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false">Close</v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog :eager="true" :retain-focus="false" :value="getDialog" fullscreen hide-overlay transition="dialog-bottom-transition">
			<FormEdit v-if="operation === 'FormEdit'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormEdit>
			<FormCreate v-if="operation === 'FormCreate'" :key="componentKey" @event="getDataFromApi" @message="propSetMessages"></FormCreate>
		</v-dialog>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando l'integrazione non potrai piu' ripristinarla.</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="dialogconfirm = false">Annulla</v-btn>
					<v-btn color="primary" text @click="confirmDelete">Conferma</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';

import KeyValueCard from '@/components/core/KeyValueCard.vue';

const FormCreate = () => import('@/components/manage/integrations/Create.vue');
const FormEdit = () => import('@/components/manage/integrations/Edit.vue');

export default {
	name: 'Integrations',
	components: { FormCreate, FormEdit, KeyValueCard },
	data() {
		return {
			componentKey: 0,
			snackbar: { snackbar: false, color: '', mode: '', timeout: 6000, text: '' },
			settings: {
				search: '',
				filters: { type: '' },
				options: {
					sortBy: ['created_at'],
					sortDesc: [true],
					page: 1,
					itemsPerPage: 15,
				},
			},
			listSize: [15, 25, 50, 100],
			searchfield: '',
			filterType: null,
			total: 0,
			page: 1,
			isMobile: false,
			operation: '',
			form: null,
			dialogconfirm: false,
			headers: [
				{ text: '', value: '', sortable: false },
				{ text: 'Icona', value: 'icona', sortable: false },
				{ text: 'Black', value: 'black', sortable: false },
				{ text: 'Nome', value: 'name' },
				{ text: 'Service', value: 'service' },
				{ text: 'Tipo', value: 'type' },
				{ text: 'Setup', value: 'setup' },
				{ text: 'Canone', value: 'canone' },
				{ text: 'Creato', value: 'created_at' },
			],
		};
	},
	computed: {
		...mapGetters({
			getDialog: 'settings/getDialog',
			getIntegrations: 'integrations/getIntegrations',
			getTypes: 'integrations/getTypes',
		}),
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		typeOptions() {
			return this.getTypes.map(t => ({ text: t, value: t }));
		},
	},
	watch: {
		'settings.options': {
			handler: function (val) {
				if (val.page === this.page) {
					this.settings.options.page = 1;
				}
				this.page = val.page;
				this.getDataFromApi();
			},
			deep: true,
		},
	},
	mounted() {
		this.setDialog(false);
		this.fetchTypes();
	},
	methods: {
		...mapMutations({
			setDialog: 'settings/setDialog',
			setPreload: 'settings/setPreload',
			setIntegration: 'integrations/setIntegration',
		}),
		...mapActions({
			fetchItems: 'integrations/asyncFetchData',
			fetchTypes: 'integrations/fetchTypes',
			deleteIntegrations: 'integrations/deleteIntegrations',
			destroyData: 'integrations/destroyData',
		}),
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			return [
				{ label: 'Service', value: item.service },
				{ label: 'Tipo', value: item.type },
				{ label: 'Setup', value: this.formatPrice(item.setup), strong: true },
				{ label: 'Canone', value: this.formatPrice(item.canone), strong: true },
				{ label: 'Creato', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' },
			];
		},
		onResize() {
			this.isMobile = window.innerWidth < 769;
		},
		formatPrice(value) {
			if (value === null || value === undefined || value === '') return '-';
			return new Intl.NumberFormat('it-IT', { style: 'currency', currency: 'EUR' }).format(value);
		},
		async getSearch() {
			this.settings.search = _.size(this.searchfield) >= 2 ? this.searchfield : '';
			this.settings.options.page = 1;
			this.getDataFromApi();
		},
		onFilterChange() {
			this.settings.options.page = 1;
			this.getDataFromApi();
		},
		async getDataFromApi() {
			try {
				this.setPreload(true);
				this.settings.filters.type = this.filterType || '';
				const result = await this.fetchItems(this.settings);
				this.total = result ? result.total : 0;
			} catch (err) {
				console.log(err);
			} finally {
				this.setPreload(false);
			}
		},
		createItem() {
			this.componentKey += 1;
			this.operation = 'FormCreate';
			this.setDialog(true);
		},
		editItem(item) {
			if (!item) return;
			this.componentKey += 1;
			this.operation = 'FormEdit';
			this.setIntegration(item);
			this.setDialog(true);
		},
		deleteItem(item) {
			this.form = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			if (!this.form || !this.form._id) return;
			this.deleteIntegrations([this.form]).then(() => {
				this.form = null;
				this.getDataFromApi();
				this.fetchTypes();
				this.snackbar = { snackbar: true, color: 'success', mode: 'multi-line', timeout: 5000, text: 'Operazione effettuata' };
			});
		},
		propSetMessages(text) {
			this.snackbar = { snackbar: true, color: 'success', mode: 'multi-line', timeout: 5000, text };
			this.operation = '';
			this.fetchTypes();
		},
	},
	beforeDestroy() {
		this.destroyData();
	},
};
</script>

<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.integration-cards,
.integration-cards tr {
	display: block;
	width: 100%;
}
.integration-cards tr,
.integration-cards tr:hover {
	background: transparent !important;
}
.integration-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.integration-cards tr:first-child td {
	padding-top: 12px !important;
}
.integration-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.integration-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
</style>
